var React = require('react');

function WindowMaximize (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M448 192H64v-84a12 12 0 0 1 12-12h360a12 12 0 0 1 12 12z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M464 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-16 160H64v-84a12 12 0 0 1 12-12h360a12 12 0 0 1 12 12z","className":"fa-primary","key":2})]);
}

WindowMaximize.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = WindowMaximize;

WindowMaximize.default = WindowMaximize;
